import { useId } from "react";

/**
 * useCSSSafeId
 * ----------------
 * A custom React hook that generates a stable, unique ID using React's `useId`
 * and makes it safe for use in CSS selectors and `querySelector`.
 *
 * React's `useId` can generate IDs with characters like `:`, which are
 * valid in HTML but break CSS selectors. This hook replaces colons with hyphens,
 * making the ID safe to use in the DOM and CSS while maintaining a system-like format.
 *
 * @returns A unique, CSS-safe ID string.
 *
 * Example usage:
 * ```tsx
 * const id = useCSSSafeId();
 *
 * return (
 *   <>
 *     <label htmlFor={id}>Name:</label>
 *     <input id={id} />
 *   </>
 * );
 *
 * // Later in JS:
 * const input = document.querySelector(`#${id}`); // Works safely
 * ```
 */
export function useCSSSafeId() {
    const id = useId();
    return id.replace(/:/g, "-");
}
